const FRIENDLY_MESSAGES: Record<string, string> = {
  "auth/popup-closed-by-user": "The sign-in window was closed before signing in.",
  "auth/cancelled-popup-request": "The sign-in request was cancelled.",
  "auth/account-exists-with-different-credential":
    "An account already exists with this email using a different sign-in method.",
  "auth/credential-already-in-use": "This credential is already linked to another account.",
  "auth/email-already-in-use": "An account with that email already exists.",
  "auth/invalid-email": "Enter a valid email address.",
  "auth/weak-password": "Password must be at least 6 characters long.",
  "auth/user-not-found": "No account found with that email.",
  "auth/wrong-password": "That password is incorrect.",
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/too-many-requests": "Too many attempts — try again in a minute.",
  "auth/configuration-not-found": "This sign-in method is not enabled in the Firebase console.",
  "auth/operation-not-allowed": "This sign-in method is not enabled in the Firebase console.",
  "auth/unauthorized-continue-uri": "The sign-in link is no longer valid.",
};

/**
 * Maps Firebase Auth error codes to human-readable messages, falling back to
 * the raw error message (or a supplied fallback) for anything else.
 */
export function authErrorMessage(cause: unknown, fallback: string): string {
  if (cause instanceof Error) {
    const code = (cause as Error & { code?: string }).code;
    if (code && FRIENDLY_MESSAGES[code]) {
      return FRIENDLY_MESSAGES[code];
    }
    if (cause.message) {
      return cause.message;
    }
  }
  return fallback;
}
